import { notificationApis } from '@apis/notificationApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchNotification = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (id: number) => {
      const response = await notificationApis.patch('/notification/{id}/', {
        path: { id },
        body: { has_read: true },
      });

      if (response[400]) {
        throw new FormError('PatchNotification', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/notification/']);
        queryClient.invalidateQueries(['/notification/unread-count/']);
      },
    },
  );
};
